import React from "react";

function UpgradeLevelIcon(props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={props.size ?? "68"}
      height={props.size ?? "68"}
      fill="none"
      viewBox="0 0 68 68"
    >
      <rect
        width="68"
        height="68"
        rx="34"
        fill="url(#paint0_radial_138_6990)"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M28.5 28.5C28.5 25.4624 30.9624 23 34 23C37.0376 23 39.5 25.4624 39.5 28.5V30.5085C39.7734 30.5148 40.0236 30.5255 40.2518 30.5442C40.8139 30.5901 41.3306 30.6887 41.816 30.936C42.5686 31.3195 43.1805 31.9314 43.564 32.684C43.8113 33.1694 43.9099 33.6861 43.9558 34.2482C44 34.7894 44 35.4537 44 36.2587V36.3V38.7V38.7413C44 39.5463 44 40.2106 43.9558 40.7518C43.9099 41.3139 43.8113 41.8306 43.564 42.316C43.1805 43.0686 42.5686 43.6805 41.816 44.064C41.3306 44.3113 40.8139 44.4099 40.2518 44.4558C39.7106 44.5 39.0463 44.5 38.2413 44.5H38.2H29.8H29.7587C28.9537 44.5 28.2894 44.5 27.7482 44.4558C27.1861 44.4099 26.6694 44.3113 26.184 44.064C25.4314 43.6805 24.8195 43.0686 24.436 42.316C24.1887 41.8306 24.0901 41.3139 24.0442 40.7518C24 40.2106 24 39.5463 24 38.7414V38.7414V38.7413V38.7V36.3V36.2587V36.2586V36.2586C24 35.4537 24 34.7894 24.0442 34.2482C24.0901 33.6861 24.1887 33.1694 24.436 32.684C24.8195 31.9314 25.4314 31.3195 26.184 30.936C26.6694 30.6887 27.1861 30.5901 27.7482 30.5442C27.9764 30.5255 28.2266 30.5148 28.5 30.5085V28.5ZM37.5 28.5V30.5H30.5V28.5C30.5 26.567 32.067 25 34 25C35.933 25 37.5 26.567 37.5 28.5ZM27.911 32.5376C27.4726 32.5734 27.2484 32.6383 27.092 32.718C26.7157 32.9097 26.4097 33.2157 26.218 33.592C26.1383 33.7484 26.0734 33.9726 26.0376 34.411C26.0008 34.8611 26 35.4434 26 36.3V38.7C26 39.5566 26.0008 40.1389 26.0376 40.589C26.0734 41.0274 26.1383 41.2516 26.218 41.408C26.4097 41.7843 26.7157 42.0903 27.092 42.282C27.2484 42.3617 27.4726 42.4266 27.911 42.4624C28.3611 42.4992 28.9434 42.5 29.8 42.5H38.2C39.0566 42.5 39.6389 42.4992 40.089 42.4624C40.5274 42.4266 40.7516 42.3617 40.908 42.282C41.2843 42.0903 41.5903 41.7843 41.782 41.408C41.8617 41.2516 41.9266 41.0274 41.9625 40.589C41.9992 40.1389 42 39.5566 42 38.7V36.3C42 35.4434 41.9992 34.8611 41.9625 34.411C41.9266 33.9726 41.8617 33.7484 41.782 33.592C41.5903 33.2157 41.2843 32.9097 40.908 32.718C40.7516 32.6383 40.5274 32.5734 40.089 32.5376C39.6389 32.5008 39.0566 32.5 38.2 32.5H29.8C28.9434 32.5 28.3611 32.5008 27.911 32.5376ZM35 38.2324C35.5978 37.8866 36 37.2403 36 36.5C36 35.3954 35.1046 34.5 34 34.5C32.8954 34.5 32 35.3954 32 36.5C32 37.2403 32.4022 37.8866 33 38.2324V40C33 40.5523 33.4477 41 34 41C34.5523 41 35 40.5523 35 40V38.2324Z"
        fill="black"
      />
      <defs>
        <radialGradient
          id="paint0_radial_138_6990"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(34 34) rotate(90) scale(34)"
        >
          <stop stopColor="#FBFF39" />
          <stop offset="1" stopColor="#FBFF39" stopOpacity="0" />
        </radialGradient>
      </defs>
    </svg>
  );
}

export default UpgradeLevelIcon;
